<!--
 * @Function: 批改作业
-->

<template>
<!-- <a-form :form="form"> -->
  <a-modal
    :title="title"
    :width="width"
    :visible="visible"
    centered
    switchFullscreen
    @ok="handleOk"
    @cancel="handleCancel"
    cancelText="关闭">
    <div class="selct-topic-modal" >
      <div class="selct-topic-right">
        <div class="table-con">
          <a-table
            ref="table"
            size="middle"
            rowKey="id"
            :scroll="{y:600}"
            :columns="columns"
            :dataSource="dataSource"
            :pagination="false">
            <span slot="tpdaac" slot-scope="text, record" style="width:200px">
              <div v-for="(item,index) in record.answerPics" :key="index">
                <a @click="previewImg(item)">图片{{index+1}}</a>
              </div>
            </span>
            <span slot="dafenac" slot-scope="text, record" style="width:200px">
              <a-form-item
                style="margin-bottom:12px;"
                :label-col="{ span: 2 }"
                :wrapper-col=" { span: 14 }"
                label=""
              >
                <a-input
                  placeholder="打分"
                  v-model="record.getScore"
                /> 
              </a-form-item>
            </span>
          </a-table>
        </div>
      </div>
      <a-modal centered :visible="previewVisible" :footer="null" @cancel="previewImgCancel">
        <img alt="example" style="width: 100%" :src="previewImage" />
      </a-modal>
    </div>
  </a-modal>
<!-- </a-form> -->
</template>

<script>
import {queryCorrectExercise,doCorrectExercise} from '@/api/api'
  export default {
    name: 'PgExamModal',
    components: {
    },
    data () {
      return {
        title: '批改',
        // form: this.$form.createForm(this),
        width: 1000,
        visible: false,
        disableSubmit: false,
        previewVisible: false,
        previewImage: '',
        dataSource: [
          // {
          //   tihao: 7,
          //   tigan: '我是题干题干题干题干题干题干题干题干题干题干题干题干题干',
          //   manfen: 15,
          //   tpda: 'https://www.elinkx.com.cn:58443/img/logo.d2d6e7a0.png'
          // }
        ],
        columns: [
          {
            title: '题号',
            align: 'center',
            dataIndex: 'sort',
            width: 80
          },
          {
            title: '答题内容',
            align: 'center',
            dataIndex: 'answer',
            width: 200
          },
          {
            title: '满分',
            align: 'center',
            dataIndex: 'exerciseScore',
            width: 80
          },
          {
            title: '图片答案',
            align: 'center',
            dataIndex: 'answerPic',
            width: 200,
            scopedSlots: { customRender: 'tpdaac' }
          },
          {
            title: '打分',
            dataIndex: 'action',
            align: 'center',
            scopedSlots: { customRender: 'dafenac' },
            width: 260
          }
        ],
        historyId:"",
        url:{
          list:"/exercise/elinkxExamPaperHistory/queryCorrectExercise"
        }
      }
    },
    methods: {
      // 预览图片答案
      previewImg (record) {
        this.previewVisible = true
        this.previewImage = record
      },
      // 预览退出
      previewImgCancel () {
        this.previewVisible = false
      },
      // 打开弹框
      open (historyId) {
        this.visible = true
        this.historyId = historyId;
        this.loadData();
      },
      // 关闭弹框
      close () {
        
        this.$emit('close')
        this.visible = false
      },
      // 提交确定
      handleOk() {
        var errflg = false;
       this.dataSource.forEach(element => {
         
        //  if(!element.getScore){
        //    this.$message.error('题号'+element.sort+'请打分！');
        //    errflg = true;
        //    return;
        //  }
         if(element.getScore > element.exerciseScore){
           this.$message.error('题号'+element.sort+'批改分大于该题总分，请修改后再提交。');
           errflg = true;
           return;
         }
       });
       if(!errflg){
        doCorrectExercise({historyList:this.dataSource}).then(res=>{
              if(res.success){
                // this.dataSource  = res.result;
                this.$emit('ok')
                this.visible = false
              }else{
                this.$message.error(res.message);
              }
          })
        }
      },
      // 关闭弹框
      handleCancel () {
        this.close()
      },
      loadData(){
        queryCorrectExercise({id:this.historyId}).then(res=>{
            if(res.success){
              this.dataSource  = res.result;
               this.dataSource.forEach(item=>{
                if(item.answerPic){
                  item.answerPics = item.answerPic.split(",");
                }else{
                  item.answerPics = [];
                }
              })
            }
        })
      }
    }
  }
</script>
<style lang="less" scoped >
  @import '~ant-design-vue/es/style/themes/default.less';
  .selct-topic-modal{
    display: flex;
    .selct-topic-right{
      flex: 1;
    }
    .table-con{
      height: 400px;
    }
  }
</style>
